import { IMetaFormat } from '../../../../../store/admin/roundFormats/store';
import { ScoreType } from '../../../../../store/admin/eventFormats/store';

import { IGBNResults } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';

type TGetRowResult = (
  gbnResults: IGBNResults,
  hole: string,
  selectedScoreType?: ScoreType | undefined,
  selectedRoundFormat?: IMetaFormat | undefined
) => number | undefined;

export const getGBNRowResult: TGetRowResult = (
  gbnResults,
  hole,
  selectedScoreType,
  selectedRoundFormat
) => {
  if (selectedScoreType) {
    const formattedScoreType = ScoreType[selectedScoreType].toLowerCase();

    const field =
      formattedScoreType === 'net' && selectedRoundFormat && selectedRoundFormat.adjustedHandicap
        ? 'adjustedNet'
        : (formattedScoreType as 'gross' | 'net');

    return gbnResults[Number(hole)][0][field];
  }
};
